const UPPER_CASE_REG_EXP = /([A-Z])/g;
function toKebabCase(value) {
  return value.replace(UPPER_CASE_REG_EXP, "-$1").toLowerCase();
}
export {
  toKebabCase
};
//# sourceMappingURL=kebabCase.js.map
